<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Appointments </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Doctor Schedule List</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Content Area -->
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: center;">Doctor Schedule Setup</h3>
                        </div>
                        <div class="card-body">   
                            <div class="row" v-if="!loading">
                                <!-- Schedule Form -->
                                <div class="col-md-6 border-end">
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="department_id"
                                                placeholder="Select Department"  
                                                @change="onChangeDepartment($event)"
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="department_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />  
                                        </div>
                                        <div class="col-md-6">
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="doctor_id"
                                                placeholder="Select Doctor"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="doctor_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                                @change="onChangeDoctor($event)"
                                                v-if="renderOptionComponent"
                                            />   
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <select v-model="weekday" class="form-select border rounded">
                                                <option disabled value="">Select Weekday</option>
                                                <option v-for="d in days" :key="d" :value="d">{{ d }}</option>
                                            </select>
                                        </div>

                                        <div class="col-md-6 mb-3">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <input type="time" v-model="start_time" class="form-control border rounded" />
                                                </div>
                                                <div class="col-md-6">
                                                    <input type="time" v-model="end_time" class="form-control border rounded" />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-6 mb-3">
                                            <input type="number" v-model="max_patient" placeholder="Max Patients"
                                                class="form-control border rounded" />
                                        </div>
                                        
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-12 text-end">
                                            <button type="button" class="btn btn-light btn-sm px-4 rounded me-2" @click="resetData()">Reset</button>
                                            <button type="button" @click="addSchedule"
                                                class="btn btn-primary btn-sm text-white px-4 rounded">
                                                <span v-show="isSubmit">
                                                    <i class="fas fa-spinner fa-spin" ></i>
                                                </span>
                                                Add Schedule
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- List -->
                                <div class="col-md-6">
                                    <div class="table-responsive p-0">
                                        <table class="table table-centered table-bordered">
                                            <thead class="table-light">
                                                <tr class="bg-gray-200 text-sm">
                                                <th class="p-2">Schedule day</th>
                                                <th class="p-2">Time</th>
                                                <th class="p-2">Max</th>
                                                <th class="p-2">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in schedules" :key="item.id">
                                                <td class="p-2">{{ item.weekday }}</td>
                                                <td class="p-2">{{ new Date('1970-01-01 ' + item.start_time).toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: true }) }} - {{ new Date('1970-01-01 ' + item.end_time).toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: true }) }}</td>
                                                <td class="p-2">{{ item.max_patient }}</td>
                                                <td class="p-2">
                                                    <button @click="deleteRow(item.id)"
                                                    class="btn btn-danger btn-sm">Delete</button>
                                                </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

        </div>
    </transition>
</template>
<script setup>
import { ref, onMounted, nextTick, getCurrentInstance} from "vue";
import axios from 'axios';
const { proxy } = getCurrentInstance();
const apiUrl = proxy.apiUrl;
const headerjson = proxy.headerjson;
const $toast = proxy.toast;
const $swal = proxy.swal;

const isSubmit = ref(false);
const showModal = ref(false);
const loading = ref(true);
const editMode = ref(false);
const disabled = ref(false);
const modalActive = ref(false);
const errors = ref({});
const btn = ref('Create');
const renderOptionComponent = ref(true);

const department_id = ref("");
const doctor_id = ref("");
const weekday = ref("");
const start_time = ref("");
const end_time = ref("");
const max_patient = ref(60);
const schedules = ref([]);
const days = ["Sat","Sun","Mon","Tue","Wed","Thu","Fri"];
const doctors = ref([]);
const doctor_options = ref([]);
const departments = ref([]);
const department_options = ref([]);
const companies = ref([]);

const multiclasses = ref({ 
    clear: '',
    clearIcon: '', 
});

// const props = defineProps({
//     language: {
//         type: Object,
//         default: () => {
//             return {
//                 lengthMenu: null,
//                 info: null,
//                 zeroRecords: null,
//                 search: null
//             }
//         },
//     },
// });

const forceRerender = () => {
    // Remove my-component from the DOM
    renderOptionComponent.value = false;

    nextTick(() => {
        // Add the component back in
        renderOptionComponent.value = true;
    });
};

const toggleModal = () => {
    modalActive.value = !modalActive.value;   
    if(!modalActive.value){
        editMode.value = false;
        btn.value = 'Create';
    } 
    errors.value = {};
    isSubmit.value = false;
    disabled.value = false;
};


const fetchCompany = () => { 
    axios.get(apiUrl+'/companies', headerjson)
    .then((res) => {
        companies.value = res.data.data; 
    })
    .catch((err) => { 
        $toast.error(err.response.data.message);
    }); 
}; 

const fetchDepartments = () => { 
    axios.get(apiUrl+'/hm/departments', headerjson)
    .then((res) => {
        departments.value = res.data.data; 
        res.data.data.map((item) => {
            department_options.value.push({label:item.name, value:item.id});
        });
    }) 
    .catch((err) => { 
        $toast.error(err.response.data.message);
    });
}; 

const fetchDoctors = () => {
    axios.get(apiUrl+"/hm/doctors", headerjson)
    .then((resp) => {
        doctors.value  = resp.data.data;
    })
    .catch((err) => { 
        $toast.error(err.response.data.message);
    })
    .finally(() => {
        loading.value = false;
    });
};

const onChangeDepartment = (dept_id) => {
    forceRerender();

    if(dept_id != 0) {
        let department_doctors = doctors.value.filter((item) => {
            return item.department_id == dept_id;
        });

        if(department_doctors.length > 0) {
            doctor_options.value = department_doctors.map((item) => { 
                return {label:item.name, value:item.id};
            });
        }
    }
};

const onChangeDoctor = (val) => {
    doctor_id.value = val;
    loadSchedules();
};

const validation = (...fields) => { 
    let obj = {};
    let validate = false;
    fields.forEach(field => {
        if (!field.value) {  
            obj[field] = field.replace("_", " ") + ' field is required';  
            errors.value = {...errors.value, ...obj};
        } else {
            validate = false;
        }
    });
};

const onkeyPress = (field) => { 
    if (errors.value[field]) {      
        delete errors.value[field];  
    }  
};

const resetData = () => {
    weekday.value = "";
    start_time.value = "";
    end_time.value = "";
    max_patient.value = 20;
    errors.value = {};
    doctor_id.value = "";
    department_id.value = "";
    schedules.value = [];
    forceRerender();
};

const loadSchedules = async () => {
    if (!doctor_id.value) return;
    const res = await axios.get(apiUrl +"/hm/doctor_schedules", {
        params: { doctor_id: doctor_id.value },
        ...headerjson
    });
    schedules.value = res.data.data;
};

const addSchedule = async () => {
    isSubmit.value = true;
    const payload = {
        doctor_id: doctor_id.value,
        weekday: weekday.value,
        start_time: start_time.value,
        end_time: end_time.value,
        max_patient: max_patient.value,
    };
    await axios.post(apiUrl +"/hm/doctor_schedules", payload, headerjson)
    .catch((err) => { 
        $toast.error(err.response.data.message);
    }).finally(() => {
        isSubmit.value = false;
    });
    await loadSchedules();
};

const deleteRow = async (id) => {
    await axios.delete(`${apiUrl}/hm/doctor_schedules/${id}`, headerjson);
    await loadSchedules();
};

const deleteItem = (item) => {
    $swal({
        title: 'Are you sure?',
        text: "You want to delete this appointment!", 
        showCancelButton: true,
        confirmButtonCategory: '#3085d6',
        cancelButtonCategory: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => { 
        if (result.value) { 
            axios.delete(apiUrl+'/hm/appointments/'+item.id, headerjson)
            .then(res => {
                if(res.status == 200){  
                    getAppointmentList();
                    $toast.success(res.data.message); 
                }else{
                    $toast.error(res.data.message);
                }
            }).catch(err => {  
                $toast.error(err.response.data.message); 
            }); 
        }
    }); 
};



onMounted(() => { 
    fetchDoctors();
    fetchDepartments();
    fetchCompany();
});
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 700px
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>